<script type="text/jsx">
import BuyNow from './buy-now.vue';
import Add from './add.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import { mapGetters } from 'vuex';
import { MIX_BUY_FLOW_UTILS } from '@/common/service/flow/utils';
import { planTypes } from '@/common/constants';

export default {
  mixins: [planPropsMixin],
  computed: {
    ...mapGetters(['mixBuyPlanType4FlowType']),
  },
  render() {
    const mixBuyPayload = [this.mixBuyPlanType4FlowType, planTypes.MASTER_CLASS];

    if (this.$context.is.add2cart) return <Add on={this.$listeners} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) {
      return <BuyNow {...{ props: { ...this.$props } }}
                     on={this.$listeners} />;
    }
    // MIX_BUY
    if (MIX_BUY_FLOW_UTILS.planIsAdd2Cart(...mixBuyPayload)) {
      return <Add on={this.$listeners} />;
    }

    return null;
  },
};
</script>
